import { BaseCanvas } from "@visactor/vrender-core";

import { TTContext2d } from "./context";

export class TTCanvas extends BaseCanvas {
    constructor(params) {
        super(params);
    }
    init() {
        this._context = new TTContext2d(this, this._dpr);
    }
    release(...params) {}
}

TTCanvas.env = "tt";
//# sourceMappingURL=canvas.js.map
